import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sales-analytics',
  templateUrl: './sales-analytics.component.html',
  styleUrls: ['./sales-analytics.component.css']
})
export class SalesAnalyticsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
